import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { i18n } from 'src/constants/I18N';

@Pipe({
    name: 'i18n',
    standalone: false
})
export class I18nPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    return i18n.tr(value);
  }
}
